export default __webpack_public_path__ + "static/media/thumbnail.0bd24750.png";